import { defineStore } from 'pinia';

export const useNavStore = defineStore('nav', {
  state: () => ({
    type: undefined
  })
});
